import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Previdência', flex: 2 },
  { title: 'Data posição' },
  { title: 'Plano' },
  { title: 'Tributação' },
  { title: 'Dia' },
  { title: 'Mês' },
  { title: 'Ano' },
  { title: 'Valor', flex: 1.5 },
];
